export const TENANTS = {
  'tenant-A1152-nippori': '1', // 経企1つ目(業務チーム)
  'tenant-A1151-meguro': '2', // 経企2つ目(企画チーム)
  'tenant-G2700-ebisu': '3', // 鋼材第二本部
  'tenant-G5F00-yoyogi': '4', // 鋼管本部
  'tenant-A41X0-sugamo': '5', // 監査部
  'tenant-G9B10-gotanda': '6', // インキュベーション室
}

const TENANT_ROUTE_NAMES = [
  'TenantRagChat',
  'TenantControlPanel',
  'TenantControlPanelConfirm',
]

/**
 * tenantId を取得
 * @param {Object} route - Vue Router の route オブジェクト
 * @returns {string}
 */
export const getTenantId = (route) => {
  const routeName = route.name ?? ''
  return TENANT_ROUTE_NAMES.some((name) => routeName.includes(name))
    ? (TENANTS[route.params?.tenant] ?? '999')
    : '999'
}

/**
 * tenant URL かどうか判定（route名 + tenant_id）
 * @param {Object} route
 * @returns {boolean}
 */
export const isTenantRoute = (route) => {
  const routeName = route.name ?? ''
  const tenant = route.params?.tenant

  const isTenantName = TENANT_ROUTE_NAMES.some((name) =>
    routeName.includes(name),
  )

  const isValidTenant = tenant && TENANTS[tenant]

  return isTenantName && isValidTenant
}
